import { useQuery } from "react-query";
import { getCourseDescription } from "../api/api";
import { Box, CircularProgress, Alert, Paper, Typography } from "@mui/material";
import DOMPurify from "dompurify";

type Props = {
  courseId: string;
};

export const CourseDescriptionComponent = (props: Props) => {
  const { courseId } = props;
  const { data, isLoading, error } = useQuery(
    ["courseDescription", courseId],
    () => getCourseDescription(courseId),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  );

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        Virhe kurssin tietojen latauksessa.
      </Alert>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: "grey.50",
        borderRadius: 1,
        "& h1, & h2, & h3, & h4, & h5, & h6": {
          color: "primary.main",
          marginTop: 2,
          marginBottom: 1,
        },
        "& p": {
          marginBottom: 1,
          lineHeight: 1.6,
        },
        "& ul, & ol": {
          marginBottom: 2,
          paddingLeft: 3,
        },
        "& li": {
          marginBottom: 0.5,
        },
        "& strong": {
          fontWeight: 600,
          color: "text.primary",
        },
      }}
    >
      {data ? (
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data) }} />
      ) : (
        <Typography variant="body2" color="text.secondary">
          Ei lisätietoja saatavilla.
        </Typography>
      )}
    </Paper>
  );
};
